import { useState, useEffect } from 'react';
import { createAppointment, getServices } from '../services/api';
import { company, profileServices } from '../content/companyContent';
import { FaAmbulance, FaPhoneAlt, FaVial } from 'react-icons/fa';
import './Appointment.css';

function Appointment() {
  const [services, setServices] = useState(profileServices);
  const [formData, setFormData] = useState({
    service: '',
    patient_name: '',
    patient_email: '',
    patient_phone: '',
    appointment_date: '',
    notes: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await getServices();
      const data = response.data.results || response.data;
      setServices(data.length ? data : profileServices);
    } catch (error) {
      console.error('Error fetching services:', error);
      setServices(profileServices);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await createAppointment(formData);
      setSubmitted(true);
      setFormData({
        service: '',
        patient_name: '',
        patient_email: '',
        patient_phone: '',
        appointment_date: '',
        notes: '',
      });
    } catch (err) {
      setError(`Online booking is not available right now. Please call ${company.phone} for urgent support.`);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="appointment-page">
      <div className="appointment-hero">
        <h1>Book Your Appointment</h1>
        <p>Schedule diagnostics, wellness camps, ambulance support, or healthcare service coordination.</p>
      </div>

      <div className="appointment-container">
        <div className="appointment-form-wrapper">
          {submitted ? (
            <div className="success-message">
              <h2>Appointment Request Sent</h2>
              <p>We will contact you shortly to confirm the appointment details.</p>
              <button onClick={() => setSubmitted(false)} className="btn-primary">
                Book Another Appointment
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="appointment-form">
              <h2>Appointment Form</h2>

              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="service">Select Service *</label>
                <select id="service" name="service" value={formData.service} onChange={handleChange} required>
                  <option value="">Choose a service</option>
                  {services.map(service => (
                    <option key={service.id} value={service.id}>
                      {service.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="patient_name">Full Name *</label>
                  <input type="text" id="patient_name" name="patient_name" value={formData.patient_name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="patient_phone">Phone Number *</label>
                  <input type="tel" id="patient_phone" name="patient_phone" value={formData.patient_phone} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="patient_email">Email Address *</label>
                <input type="email" id="patient_email" name="patient_email" value={formData.patient_email} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label htmlFor="appointment_date">Preferred Date & Time *</label>
                <input type="datetime-local" id="appointment_date" name="appointment_date" value={formData.appointment_date} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label htmlFor="notes">Additional Notes</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Mention location, service requirement, or urgency..."
                  rows="4"
                />
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Booking...' : 'Book Appointment'}
              </button>
            </form>
          )}
        </div>

        <div className="appointment-info">
          <div className="info-card">
            <h3><FaPhoneAlt /> Call Us</h3>
            <p>{company.phone}</p>
          </div>
          <div className="info-card">
            <h3><FaAmbulance /> 24/7 Ambulance</h3>
            <p>BLS and ALS-equipped emergency response and inter-hospital transfer support.</p>
          </div>
          <div className="info-card">
            <h3><FaVial /> Frequent Requests</h3>
            <ul>
              <li>Blood collection</li>
              <li>Wellness camps</li>
              <li>Doctor consultation</li>
              <li>Healthcare logistics</li>
              <li>TPA and empanelment</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Appointment;
